import { Suspense } from 'react';
import './App.css';
import LaunchingSoon from './components/LaunchingSoon';
import PatentContextProvider from './context/PatentContextProvider';
import Pillar from './components/FivePillars';
import 'bootstrap/dist/css/bootstrap.min.css';
import Services from './components/Services';
import PressHero from './components/Press';
import ContactUs from './components/Contact';
import Patents from './components/Patent';
import Sms from './components/Sms';
import About from './components/About';
import Features from './components/Features';
import Blog from './components/Blog';
import Leadership from './components/Leadership';
import History from './components/History';
import Faqs from './components/Faqs';
import CaseStudies from './components/Case';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import Marketing from './components/Marketing';
import Eula from './components/Eula';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";


function App() {
  return (
    <div>
      <PatentContextProvider>
        <Router>
          <Routes>
            <Route path='/' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <LaunchingSoon /></Suspense>} />
            <Route path='/services' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Services /></Suspense>} />
            <Route path='/press' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <PressHero /></Suspense>} />
            <Route path='/contact' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <ContactUs /></Suspense>} />
            <Route path='/patents' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Patents /></Suspense>} />
            <Route path='/sms' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Sms /></Suspense>} />
            <Route path='/feature' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Features /></Suspense>} />
            <Route path='/about' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <About /></Suspense>} />
            <Route path='/seven-pillars' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Pillar /></Suspense>} />
            <Route path='/blog' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Blog /></Suspense>} />
            <Route path='/leadership' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Leadership /></Suspense>} />
            <Route path='/history' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <History /></Suspense>} />
            <Route path='/case' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <CaseStudies /></Suspense>} />
            <Route path='/faqs' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Faqs /></Suspense>} />
            <Route path='/terms' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Terms /></Suspense>} />
            <Route path='/privacy' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Privacy /></Suspense>} />
            <Route path='/marketing' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Marketing /></Suspense>} />
            <Route path='/eula' element={<Suspense fallback={<div className="h-screen bg-white">Loading...</div>}> <Eula /></Suspense>} />
          </Routes>
        </Router>
      </PatentContextProvider>
    </div>
  );
}

export default App;
